import { connect } from 'react-redux'
import EmailConfirmationRequired from './email-confirmation-required'
import { withMe } from 'pobble-components/dist/pobble-user'
import { apiResendConfirmationEmail } from '../../../../../common/api/magic-links'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { me }) => ({
  emailId: me.account.email_identity.id
})

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  resentConfirmation: () =>
    apiResendConfirmationEmail(stateProps.emailId).catch(errorHandler)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(EmailConfirmationRequired)
)
